import ReactDOM from 'react-dom/client';
import App from './app/App';
import './app/utils/translation/i18n';
import './index.css';
// import SnowFall from "app/components/SnowFall/SnowFall";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <>
    <App />
    {/* <SnowFall/>*/}
  </>
);
